import axiosInstance from '../../../../config/axiosInstance';
const  SerialFormatService = {
    async GetSerialFormat(redirectCallback) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetSerialFormat?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetSerialFormatByID(redirectCallback,ID) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetSerialFormatByID?ID=${ID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteSerialFormat(ID,redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Setup/DeleteSerialFormat?ID=${ID}`);
           return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default SerialFormatService;